import { ISelectedPromotionInfoSchema } from '../../../repositories/billing-tariffs/entities/PublishTerms/SelectedPromotionInfoSchema';
import { IMappers } from '../../../repositories/billing-tariffs/v3/check-service';
import { ECheckServiceErrorCode } from '../../../types/reducers/checkoutInfo';
import { ICheckServiceFail, ICheckServiceSuccess } from '../types';
import { mapAuction } from './mapAuction';
import { mapCheckoutInfo } from './mapCheckoutInfo';
import { mapSelectedPromotionInfo } from './mapSelectedPromotionInfo';
import { mapBalance } from './mapBalance';
import { mapRecommendedDepositAmount } from './mapRecommendedDepositAmount';

export const mappers: IMappers<ICheckServiceSuccess, ICheckServiceFail> = {
  200: rawResponse => {
    const response = rawResponse || {};
    const selectedPromotionInfo = response.selectedPromotionInfo || ({} as ISelectedPromotionInfoSchema);

    return {
      success: true,
      payload: mapCheckoutInfo(response),
      selectedPromotionInfo: mapSelectedPromotionInfo(selectedPromotionInfo),
      auction: mapAuction(selectedPromotionInfo),
      balance: mapBalance(response.balanceInfo),
      recommendedDepositAmount: mapRecommendedDepositAmount(response.recommendedDepositAmount),
    };
  },
  400: () => ({
    success: false,
    payload: ECheckServiceErrorCode.badRequest,
  }),
};
